"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Dialog = __importStar(require("@radix-ui/react-dialog"));
const icon_1 = __importDefault(require("../../icon"));
const buttons_css_1 = __importDefault(require("../../../styles/global_ui/buttons.css"));
const layout_css_1 = __importDefault(require("../../../styles/global_ui/layout.css"));
const util_css_1 = __importDefault(require("../../../styles/global_ui/util.css"));
const dialog_css_1 = __importDefault(require("./dialog.css"));
const DialogRadix = ({ asModal, children, classList, defaultOpen, hasClose, hasOverlay, id, onInteractOutside, onOpenChange, onOpenAutoFocus, open, testId, title, hasTransitions, trigger, }) => (react_1.default.createElement(Dialog.Root, { defaultOpen: defaultOpen, modal: asModal, onOpenChange: onOpenChange, open: open },
    trigger && react_1.default.createElement(Dialog.Trigger, { className: `${classList?.trigger}` }, trigger),
    react_1.default.createElement(Dialog.Portal, null,
        hasOverlay && react_1.default.createElement(Dialog.Overlay, null),
        react_1.default.createElement(Dialog.Content, { "aria-label": title, className: `${util_css_1.default.borderRadiusLarge} ${util_css_1.default.border} ${util_css_1.default.boxShadow} ${dialog_css_1.default.dialogContent} ${hasTransitions ? dialog_css_1.default.transitionEnabled : ''} ${classList?.container}`, "data-testid": testId, id: id, onInteractOutside: onInteractOutside, onOpenAutoFocus: onOpenAutoFocus },
            hasClose && (react_1.default.createElement(Dialog.Close, { "aria-label": "close", className: `${layout_css_1.default.inlineFlex} ${util_css_1.default.posAbsolute} ${layout_css_1.default.borderNone} ${util_css_1.default.borderRadiusCircle} ${layout_css_1.default.flexCenterCenter} ${buttons_css_1.default.unset} ${buttons_css_1.default.white} ${dialog_css_1.default.dialogClose}` },
                react_1.default.createElement(icon_1.default, { name: "close", size: 12 }))),
            children))));
exports.default = DialogRadix;
